import { render, staticRenderFns } from "./GroupForm.vue?vue&type=template&id=0da38cde&scoped=true&"
import script from "./GroupForm.vue?vue&type=script&lang=js&"
export * from "./GroupForm.vue?vue&type=script&lang=js&"
import style0 from "./GroupForm.vue?vue&type=style&index=0&id=0da38cde&scoped=true&lang=css&"
import style1 from "./GroupForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da38cde",
  null
  
)

export default component.exports